import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_WIND_ANGLE, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { useDispatch } from "react-redux";
import { Range } from "../../../../range/range";
import { Control } from "../../../../control/control";
import { setWindAngle } from "../../../../../features/config/config.slice";
export const SnowflakeWindAngle = ({ index, layer, }) => {
    const dispatch = useDispatch();
    return (_jsx(Control, { name: "Angle", tooltip: "The angle of the wind", showOutput: true, reset: () => {
            const angle = index < DEFAULT_LAYERS.length ? DEFAULT_LAYERS[index].wind.angle : DEFAULT_WIND_ANGLE;
            dispatch(setWindAngle({
                index,
                angle
            }));
        }, value: layer.wind.angle, onChange: (event) => dispatch(setWindAngle({
            index,
            angle: Number(event.target.value),
        })), children: _jsx(Range, { min: "0", max: "360", step: "1" }) }));
};
